import ApiConnector from '../connector/ApiConnector';

export default class MenuRepository {
    private apiConnector:ApiConnector
    private static menu:any

    constructor() {
        this.apiConnector = new ApiConnector()
    }

    private requestMenu() {
        return this.apiConnector.get('/api/menu').then(menu => {
            MenuRepository.menu = menu
            return MenuRepository.menu;
        })
    }

    public getMenu() {
        if (MenuRepository.menu === undefined) {
            return this.requestMenu()
        }
        return new Promise<any>((resolve) => {
            resolve(MenuRepository.menu)
        })
       
    }
}